import type { KAPLAYCtxT, GameObj, Vec2 } from 'kaplay'
import { getTiledSize } from '../utils.ts'

type Gender = 'male' | 'female'
type Genders = Record<Gender, string>

const genders: Genders = {
  male: 'player_male',
  female: 'player_female',
}

export function usePlayer(k: KAPLAYCtxT) {
  const playerWidth = getTiledSize(1)
  const playerHeight = getTiledSize(2)
  const areaPadding = 2

  function setPlayer(playerPos: Vec2, gender: Gender = 'male') {
    const sfxFootsteps = k.play('sfx_footstep', { loop: true, volume: 5 })
    sfxFootsteps.stop()

    const player = k.add([
      k.sprite(genders[gender], {
        frame: 1,
        width: playerWidth,
        height: playerHeight,
      }),
      k.area({
        shape: new k.Rect(
          k.vec2(0, playerHeight / 4),
          playerWidth - 2 * areaPadding,
          playerWidth - 2 * areaPadding,
        ),
      }),
      k.body(),
      k.pos(playerPos),
      k.anchor('center'),
      k.layer('objects'),
      k.named('player'),
      'player',
      {
        speed: getTiledSize(5),
        isMoving: false,
        moveDirection: 'up',
        setPos(this: GameObj, pos: Vec2) {
          this.pos = pos
        },
        setControls(this: GameObj) {
          k.onButtonPress((key) => {
            if (key === 'up') {
              this.play('run_up')
              this.isMoving = true
              this.moveDirection = 'up'
              sfxFootsteps.play()
            } else if (key === 'down') {
              this.play('run_down')
              this.isMoving = true
              sfxFootsteps.play()
              this.moveDirection = 'down'
            } else if (key === 'right') {
              this.play('run_right')
              this.isMoving = true
              sfxFootsteps.play()
              this.moveDirection = 'right'
            } else if (key === 'left') {
              this.play('run_left')
              this.isMoving = true
              sfxFootsteps.play()
              this.moveDirection = 'left'
            }
          })

          k.onButtonRelease((key) => {
            if (key === 'up') {
              this.play('face_up')
              this.isMoving = false
              sfxFootsteps.stop()
              this.moveDirection = 'none'
            } else if (key === 'down') {
              this.play('face_down')
              this.isMoving = false
              sfxFootsteps.stop()
              this.moveDirection = 'none'
            } else if (key === 'right') {
              this.play('face_right')
              this.isMoving = false
              sfxFootsteps.stop()
              this.moveDirection = 'none'
            } else if (key === 'left') {
              this.play('face_left')
              this.isMoving = false
              sfxFootsteps.stop()
              this.moveDirection = 'none'
            }
          })

          k.onButtonDown((key) => {
            if (key === 'up' && this.moveDirection === 'up') {
              this.move(0, -this.speed)
            } else if (key === 'down' && this.moveDirection === 'down') {
              this.move(0, this.speed)
            } else if (key === 'right' && this.moveDirection === 'right') {
              this.move(this.speed, 0)
            } else if (key === 'left' && this.moveDirection === 'left') {
              this.move(-this.speed, 0)
            }
          })
        },
      },
    ])

    player.setControls()

    return player
  }

  return {
    setPlayer,
  }
}
